import { API_ENDPOINT } from 'env'

export const deletarUnidade = async ({ id }) => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${parsed.auth.token}`,
    },
  }
  const res = await fetch(`${API_ENDPOINT}/unidades/${id}`, options)
  const data = await res.text()
  if (!res.ok) {
    const error = new Error('Erro ao deletar unidade')
    error.status = res.status
    error.data = data
    throw error
  }

  return data
}
export const listarUnidades = async empresaId => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)
  const response = await fetch(`${API_ENDPOINT}/unidades?empresaId=${empresaId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${parsed.auth.token}`,
    },
  })

  if (!response.ok) {
    throw new Error('Erro ao listar unidades')
  }

  return await response.json()
}
